import(/* webpackMode: "eager" */ "/vercel/path0/app/(routes)/refer/page.jsx");
